import { render, staticRenderFns } from "./pbx-overview.vue?vue&type=template&id=daaa57a0&"
import script from "./pbx-overview.vue?vue&type=script&lang=ts&"
export * from "./pbx-overview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports